import { ExternalLink } from "lucide-react";
import { useEffect } from "react";

import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogHeader,
	DialogTitle,
} from "@/components/ui/dialog";

interface RdoPreviewDialogProps {
	objectUrl: string;
	onClose: () => void;
}

export function RdoPreviewDialog({
	objectUrl,
	onClose,
}: RdoPreviewDialogProps) {
	useEffect(() => () => URL.revokeObjectURL(objectUrl), [objectUrl]);

	function handleOpenChange(open: boolean) {
		if (open) return;
		URL.revokeObjectURL(objectUrl);
		onClose();
	}

	return (
		<Dialog open onOpenChange={handleOpenChange}>
			<DialogContent className="rdo-preview-dialog">
				<DialogHeader className="rdo-preview-dialog__header">
					<DialogTitle>Prévia do Relatório de Obra</DialogTitle>
					<DialogDescription>
						Documento não finalizado, gerado com o conteúdo atual do rascunho.
					</DialogDescription>
					<a
						className="rdo-preview-dialog__open"
						href={objectUrl}
						target="_blank"
						rel="noopener"
					>
						<ExternalLink /> Abrir em nova aba
					</a>
				</DialogHeader>
				<iframe
					title="Prévia do RDO"
					className="rdo-preview-dialog__frame"
					src={objectUrl}
				/>
			</DialogContent>
		</Dialog>
	);
}
